/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskResponseDto } from '../../models/core-project-subtask-response-dto';

export interface ProjectSubtasksControllerFindByProjectManager$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The project manager user ID to filter projects by.
 */
  projectManagerId: string;
}

export function projectSubtasksControllerFindByProjectManager(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerFindByProjectManager$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerFindByProjectManager.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('projectManagerId', params.projectManagerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>;
    })
  );
}

projectSubtasksControllerFindByProjectManager.PATH = '/o2-core/project-subtasks/{tenant}/project-manager/{projectManagerId}';
